export function getToastNotifications(state) {
  return getLocalState(state).toastNotifications;
}

export function generateToastNotificationId() {
  return `${Date.now()}`;
}

function getLocalState(state) {
  return state.toasts;
}



// WEBPACK FOOTER //
// ./src/selectors/toastsSelectors.js